import get from 'lodash/get';
import debounce from 'lodash/debounce';

function TenantAddCtrl($log,
                       $location,
                       TenantsService,
                       DistributorsService,
                       TimezonesService,
                       $state,
                       sweet,
                       ProgressBarService,
                       SessionsService,
                       AuthV2Service) {
  "ngInject";

  let vm = this;
  vm.gameStopServer = $location.host().indexOf('provisioning-gamestop') > -1;
  vm.currentTenant = {
    addonGids: [],
    adminEmails: [],
    customerName: undefined,
    defaultHoursOfOperation: undefined,
    defaultShowContentProgress: false,
    domainGid: undefined,
    editionGid: undefined,
    intacctId: undefined,
    lid: undefined,
    name: undefined,
    notificationEmails: [],
    timezone: 'America/Chicago',
    supportNotes: undefined,
    usageType: 'Installed'
  };
  vm.distributorDomains = [];
  vm.timezones = [];
  vm.admin = SessionsService.getIsAdmin();
  vm.selectedEditionName = 'Lite';
  vm.editions = [];
  vm.editionAddonList = [];

  vm.initialize = async function () {
    let timezonePromise = TimezonesService.getCustomTimezones();
    timezonePromise.then(data => vm.timezones = data);
    vm.currentDistributorKey = SessionsService.getCurrentDistributorKey();

    try {
      await vm.getEditionAddOnsList().catch(err => {
        console.error('Failed to get edition addon list', err);
        sweet.show('Oops...', 'Failed to get edition addon list', 'error');
      });
      const domains = await TenantsService.getTenantV2Domains(SessionsService.getCurrentDistributorCode());

      const hasOrgEdges = get(domains, 'data.data.organization.domains.edges.length');
      let mappedOrg = [];

      if (hasOrgEdges) {
        const edges = get(domains, 'data.data.organization.domains.edges');

        mappedOrg = edges.map(e => ({
          id: e.node.id,
          lid: e.node.lid,
          name: e.node.name
        }));
      }
      
      vm.distributorDomains = mappedOrg;
    } catch(err) {
      console.error(err);
    }
  };

  vm.getEditionAddOnsList = async function(){
    try {
      const ngEditionsResp = await AuthV2Service.getEditions();
      const ngEditionsData = _.get(ngEditionsResp, 'data.data.editions');
      const ngAddonsData = _.get(ngEditionsResp, 'data.data.addons');

      vm.editionAddonList = ngAddonsData.filter(x => x.name);
      vm.editions = ngEditionsData;
    } catch (err) {
      console.error(err);
      return ToastsService.showErrorToast('Oops. We are currently unable retrieve the editions list at this time.');
    }
  };

  vm.checkItemSelected = (item) => vm.currentTenant.addonGids.find(x => x.lid === item.lid);

  vm.toggleAddOns = (item) => {
    if (vm.currentTenant.addonGids && vm.currentTenant.addonGids.find(x => x.lid === item.lid)) {
      const idx = vm.currentTenant.addonGids.findIndex(x => x.lid === item.lid);
      vm.currentTenant.addonGids.splice(idx, 1);
    } else {
      vm.currentTenant.addonGids.push(item);
    }
  }

  vm.onClickSaveButton = debounce(async () => {
    const payload = {
      addonGids: vm.currentTenant.addonGids.map(x => x.gidV3),
      adminEmails: vm.currentTenant.adminEmail && vm.currentTenant.adminEmail.length ? vm.currentTenant.adminEmail.split(',') : [],
      customerName: vm.currentTenant.customerName,
      defaultShowContentProgress: vm.currentTenant.defaultShowContentProgress,
      editionGid: vm.currentTenant.editionGid.gidV3,
      intacctId: vm.currentTenant.intacctId,
      lid: vm.currentTenant.lid,
      name: vm.currentTenant.name,
      notificationEmails: vm.currentTenant.notificationEmails.length ? vm.currentTenant.notificationEmails.split(',') : [],
      timezone: vm.currentTenant.timezone,
      usageType: vm.currentTenant.usageType.toUpperCase(),
      domainGid: vm.currentTenant.domainGid
    }

    ProgressBarService.start();

    let promise = TenantsService.postTenantV2(payload);
    return promise.then(vm.onSuccessTenantSave, vm.onFailureTenantSave);
  }, 600);

  vm.onSuccessTenantSave = function (resp) {
    ProgressBarService.complete();

    if (get(resp, 'data.errors.length')) {
      console.error(get(resp, 'data.errors'));
      $log.error(get(resp, 'data.errors'));
      sweet.show('Oops...', 'Failed to create tenant', 'error');
    } else {
      return $state.go('main.tenants');
    }
  };

  vm.onFailureTenantSave = function (errorObject) {
    ProgressBarService.complete();

    $log.error(errorObject);
    sweet.show('Oops...', 'Not everything needed for tenant was created in Content Manager or CDM.', 'error');
  };

  vm.cancel = () => {
    $state.go("main.tenants")
  };

  vm.autoGenerateTenantCode = function () {
    let newTenantCode = '';
    if (vm.currentTenant.name) {
      newTenantCode = vm.currentTenant.name.toLowerCase();
      newTenantCode = newTenantCode.replace(/\s+/g, '_');
      newTenantCode = newTenantCode.replace(/\W+/g, '');
    }
    vm.currentTenant.lid = newTenantCode;
  };

  return vm;
}
export {TenantAddCtrl}
